export default __webpack_public_path__ + "f6ed80747c5142211b21a54f2a169978.png";